const SNOWPLOW_ERROR_BOT_USER_AGENT_PATTERN =
  /bot|crawler|spider|crawling|preview|headless|lighthouse|pagespeed|slurp|bingpreview|facebookexternalhit|curl|wget/i;
const SNOWPLOW_BROWSER_EXTENSION_URL_PATTERN =
  /^(chrome-extension|moz-extension|safari-web-extension):\/\//i;
const SNOWPLOW_ERROR_NOISE_MESSAGES = [
  'HTMLIFrameElement object could not be cloned',
  'Event `Event` (type=error) captured as promise rejection',
  'Failed to connect to MetaMask',
  'Should not already be working',
  'runtime.sendMessage',
  'Java object is gone',
  /Failed to load .+ script/,
];

export const SNOWPLOW_ERROR_DENY_URLS = [
  'apps.voc.ai',
  'analytics.google.com',
  'fonts.googleapis.com',
  '.gstatic.com',
  '.bytedance.com',
  '.tiktok.com',
  '.emarsys.net',
  '.applovin.com',
  '.bing.com',
  '.albss.com',
  '.clarity.ms',
  '.scarabresearch.com',
  '.shulex-voc.com',
  '.facebook.net',
  '.pepperjam.com',
  '.doubleclick.net',
  '.dwin1.com',
  '.apitd.net',
  '.creativecdn.com',
  '.trustdecision.com',
  '.criteo.net',
  '.ads-twitter.com',
  '.axon.ai',
  '.zijieapi.com',
  '.roeye.com',
  '.roeyecdn.com',
  '.awswaf.com',
];

type SnowplowErrorNoiseInput = {
  userAgent?: string;
  filename?: string;
  message?: string;
};

type SnowplowFilterInput = SnowplowErrorNoiseInput | ErrorEvent | Event;

export function isSnowplowBotUserAgent(userAgent: string) {
  return SNOWPLOW_ERROR_BOT_USER_AGENT_PATTERN.test(userAgent);
}

export function isSnowplowBrowserExtensionUrl(url: string) {
  return SNOWPLOW_BROWSER_EXTENSION_URL_PATTERN.test(url);
}

function isSnowplowKnownThirdPartyUrl(url: string) {
  return SNOWPLOW_ERROR_DENY_URLS.some((denyUrl) => url.includes(denyUrl));
}

function matchesSnowplowNoiseMessage(message: string, pattern: string | RegExp) {
  if (typeof pattern === 'string') {
    return message.includes(pattern);
  }

  return pattern.test(message);
}

function getStringProperty(source: unknown, key: string) {
  if (!source || typeof source !== 'object') {
    return '';
  }

  const value = (source as Record<string, unknown>)[key];

  return typeof value === 'string' ? value : '';
}

function getNavigatorUserAgent() {
  if (typeof navigator === 'undefined') {
    return '';
  }

  return navigator.userAgent || '';
}

function getEventTargetUrl(input: SnowplowFilterInput) {
  const target = (input as Event).target;
  const currentTarget = (input as Event).currentTarget;

  return (
    getStringProperty(target, 'src') ||
    getStringProperty(target, 'href') ||
    getStringProperty(currentTarget, 'src') ||
    getStringProperty(currentTarget, 'href')
  );
}

export function shouldTrackSnowplowError(input: SnowplowFilterInput) {
  const userAgent = getStringProperty(input, 'userAgent') || getNavigatorUserAgent();
  const filename = getStringProperty(input, 'filename') || getEventTargetUrl(input);
  const message = getStringProperty(input, 'message');

  if (isSnowplowBotUserAgent(userAgent)) {
    return false;
  }

  if (isSnowplowBrowserExtensionUrl(filename)) {
    return false;
  }

  if (isSnowplowKnownThirdPartyUrl(filename)) {
    return false;
  }

  return !SNOWPLOW_ERROR_NOISE_MESSAGES.some((pattern) =>
    matchesSnowplowNoiseMessage(message, pattern),
  );
}
